import type {Trackables} from '@app/types/tracking';
import type {GAEvent} from '@deezer/tracking';

export const pageViewsIds = [
	'download',
	'devices_cars',
	'devices_computer',
	'devices_mobile',
	'devices_soundsystems',
	'devices_tv',
	'devices_voice',
	'devices_wearables',
	'features',
	'features_flow',
	'features_hifi',
	'features_lyrics',
	'features_music_quiz',
	'features_offline',
	'features_shaker',
	'features_songcatcher',
	'features_transfer_playlist',
	'features_waze',
	'features_ai_labelling',
	'ai_music_detector',
	'moments',
	'moments_christmas',
	'moments_lareleve2023',
	'moments_summer',
	'moments_workout',
	'reviews',
	'passculture',
] as const;

export type CDPPageViewId = (typeof pageViewsIds)[number];

export const getDevicePageViewId = (
	pageName: string,
): CDPPageViewId | undefined => {
	switch (pageName) {
		case 'computer':
			return 'devices_computer';
		case 'cars':
			return 'devices_cars';
		case 'mobile':
			return 'devices_mobile';
		case 'soundsystems':
			return 'devices_soundsystems';
		case 'tv':
			return 'devices_tv';
		case 'voice':
			return 'devices_voice';
		case 'wearables':
			return 'devices_wearables';
	}
};

export const toGAEvent = (data: Partial<Trackables>): GAEvent => {
	const result: Record<string, string | boolean | undefined> = {};

	for (const [key, value] of Object.entries(data)) {
		if (typeof value === 'number') {
			result[key] = String(value);
		} else if (
			typeof value === 'boolean' ||
			typeof value === 'string' ||
			value === undefined
		) {
			result[key] = value;
		}
	}

	return result as GAEvent;
};
